module.exports = __webpack_public_path__ + "img/email.cf1c5631.svg";